export type AiPanelIconToken =
  | 'success'
  | 'warning'
  | 'critical'
  | 'remove'
  | 'company'
  | 'email'
  | 'address'
  | 'phone'
  | 'website'
  | 'shield'
  | 'copy'
  | 'link'
  | 'externalLink';

export type AiPanelTone =
  | 'default'
  | 'success'
  | 'warning'
  | 'critical'
  | 'secondary'
  | 'link'
  | 'emailAge';

export type AiPanelLink = {
  text: string;
  href: string;
  external?: boolean;
};

export type AiPanelCopyable = {
  copyable?: boolean;
  copyText?: string;
};

export enum AiPanelBlockType {
  Text = 'Text',
  BulletList = 'BulletList',
  KeyValueRows = 'KeyValueRows',
  IconRows = 'IconRows',
  Links = 'Links',
  Divider = 'Divider',
  Group = 'Group'
}

export type AiPanelTextBlock = {
  type: AiPanelBlockType.Text;
  text: string;
  bold?: boolean;
  tone?: AiPanelTone;
} & AiPanelCopyable;

export type AiPanelBulletItem = {
  text: string;
  link?: AiPanelLink;
  generatedByAi?: boolean;
};

export type AiPanelBulletListBlock = {
  type: AiPanelBlockType.BulletList;
  items: AiPanelBulletItem[];
  maxItems?: number;
  charLimit?: number;
};

export type AiPanelKeyValueRowsBlock = {
  type: AiPanelBlockType.KeyValueRows;
  rows: Array<
    {
      label: string;
      value: string;
      valueTone?: AiPanelTone;
      valueLink?: AiPanelLink;
    } & AiPanelCopyable
  >;
};

export type AiPanelIconRowsBlock = {
  type: AiPanelBlockType.IconRows;
  rows: Array<
    {
      icon?: AiPanelIconToken;
      text: string;
      link?: AiPanelLink;
      badge?: { text: string; tone: AiPanelTone };
      generatedByAi?: boolean;
    } & AiPanelCopyable
  >;
};

export type AiPanelLinksBlock = {
  type: AiPanelBlockType.Links;
  links: AiPanelLink[];
};

export type AiPanelDividerBlock = { type: AiPanelBlockType.Divider };

export type AiPanelGroupBlock = {
  type: AiPanelBlockType.Group;
  title?: string;
  titleIcon?: AiPanelIconToken;
  titleIconTone?: AiPanelTone;
  blocks: AiPanelBlock[];
};

export type AiPanelBlock =
  | AiPanelTextBlock
  | AiPanelBulletListBlock
  | AiPanelKeyValueRowsBlock
  | AiPanelIconRowsBlock
  | AiPanelLinksBlock
  | AiPanelDividerBlock
  | AiPanelGroupBlock;

export type AiPanelCardModel = {
  title?: string;
  titleLink?: AiPanelLink;
  titleIcon?: AiPanelIconToken;
  titleIconTone?: AiPanelTone;
  headerAction?: AiPanelLink;
  extraLink?: AiPanelLink;
  blocks: AiPanelBlock[];
  noBackground?: boolean;
};

export type AiPanelContract = {
  title: string;
  subtitle?: string;
  introMessage: string;
  updatedAt?: string;
  feedbackPrompt?: string;
  cards: AiPanelCardModel[];
};
